import {
    buildAgendaStyleSingleLine,
    mergeAppointmentPayload,
    type SchedulerAppointmentTemplateData,
} from '@/components/agenda/agenda-appointment-display';
import { Box } from '@mui/material';
import { formatMessage } from 'devextreme/localization';
import { useTranslate } from 'react-admin';

/**
 * Vista mes: mismo contenido que los ítems de agenda, en una sola línea:
 * `cliente | sitio | lugar - postal, ciudad · tipo`
 */

const allDayPrefix = ` ${formatMessage('dxScheduler-allDay')}: `;

export default function AgendaMonthAppointmentItem(props: { data?: SchedulerAppointmentTemplateData }) {
    const translate = useTranslate();
    const apt = mergeAppointmentPayload(props.data);
    if (!apt) {
        return null;
    }

    const isAllDay = Boolean(apt.allDay);
    const combined = buildAgendaStyleSingleLine(apt, translate);
    const displayText = isAllDay ? `${allDayPrefix}${combined}`.trim() : combined;

    return (
        <Box
            sx={{
                display: 'grid',
                alignItems: 'center',
                alignContent: 'center',
                fontWeight: 700,
            }}
        >
            {displayText}
        </Box>
    );
}
